export default __webpack_public_path__ + "static/media/alex1.d8c01298.jpg";